import React from 'react';

// This component is a stub to support React Native web
export default function TabViewPagerAndroid() {
  return <p>TabViewPagerAndroid is not supported on web.</p>;
}
